module.exports = __webpack_public_path__ + "media/images/guk100-f0d365ba.png";